import React, { useEffect, useState, useCallback } from 'react'
import { Route, Redirect } from 'react-router-dom'

import { ApplicationPaths, QueryParameterNames } from './ApiAuthorizationConstants'
import authService from './AuthorizeService';

export default function AuthorizeRoute ({ component: Component, path, ...rest }) {
    const [isReady, setIsReady] = useState(false);
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    const populateAuthenticationState = useCallback(async () => {
        const isAuthenticated = await authService.isAuthenticated();
        setIsAuthenticated(isAuthenticated);
        setIsReady(true);
    }, [setIsAuthenticated, setIsReady]);

    const authenticationChanged = useCallback(async () => {
        setIsReady(false);
        setIsAuthenticated(false);
        await populateAuthenticationState();
    }, [setIsReady, setIsAuthenticated, populateAuthenticationState]);

    useEffect(() => {
        const subscription = authService.subscribe(authenticationChanged);
        populateAuthenticationState();
        return () => authService.unsubscribe(subscription);
    }, [authenticationChanged, populateAuthenticationState]);

    if (!isReady) {
        return <div></div>;
    }

    const link = document.createElement("a");
    link.href = path;
    
    const returnUrl = `${link.protocol}//${link.host}${link.pathname}${link.search}${link.hash}`;
    const redirectUrl = `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(returnUrl)}`;

    return (
        <Route
            {...rest}
            path={path}
            render={props => {
                if (isAuthenticated) {
                    return <Component {...props} />
                } else {
                    return <Redirect to={redirectUrl} />
                }
            }} 
        />
    );
}
